import Image from 'next/image';

import hero1 from '../../assets/images/hero1.png';
import hero2 from '../../assets/images/hero2.png';
import hero3 from '../../assets/images/hero3.png';
import hero4 from '../../assets/images/hero4.png';
import styles from './Hero.module.scss';

export const HeroImage = () => (
  <>
    <picture>
      <Image className={styles.image} src={hero1} alt="hero1" unoptimized />
    </picture>
    <picture>
      <Image className={styles.image} src={hero2} alt="hero2" unoptimized />
    </picture>
    <picture>
      <Image className={styles.image} src={hero3} alt="hero3" unoptimized />
    </picture>
    <picture>
      <Image className={styles.image} src={hero4} alt="hero4" unoptimized />
    </picture>
  </>
);
